import script from "./AppOrderActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppOrderActions.vue?vue&type=script&setup=true&lang=ts"

import "./AppOrderActions.vue?vue&type=style&index=0&id=cdfd3304&lang=scss"

const __exports__ = script;

export default __exports__